// True while scripts/prerender.js renders a page to static HTML. Parts drawn
// from a measurement of the screen (mock canvases, the hero diagram's lines,
// the step layouts) render their unmeasured state instead, so the saved HTML
// suits every screen width and holds the first frame.
export const isPrerender = typeof window !== 'undefined' && window.__PRERENDER__ === true;
